import sample_01 from './100_47751.jpg';

export const dynamicElementsImpressions = {
    sample_01,
};
